module.exports = {"id":"177448","name":"Gustav Svensson","rating":"74","photo":"./data/images/photos/1/177448.png","club":{"name":"Seattle Sounders","logo":"./data/images/clubs/SeattleSounders.png"},"positions":["MDC","DC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GustavSvensson0.json
// module id = 1668
// module chunks = 0